import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/phpWebDevData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const PHPWebDevelopmentService = () => {
  useMetaTags({
    title: "Custom PHP Web Development Agency | PHP Development Services",
    description:
      "Warrgyizmorsch is a leading PHP web development company that provides customized, scalable, and secure PHP solutions to enable businesses to expand and thrive online",
    keywords:
      "PHP development, php developers, php development services, php web development agency, php programming language, php web development, php website development, php development company, php development, php web development company, PHP Web Development Agency",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Custom PHP Web Development Agency
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/phpwebdev.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  We at Warrgyizmorsch are a premier PHP web development company
                  which we put forward to create dynamic, secure, and scalable
                  web solutions for growth of your business. We work hand in
                  hand with our clients to see their innovative ideas turn into
                  practical, high performing digital realities. Our team of
                  experts does what it takes in terms of design and PHP
                  development applications which range from interactive web
                  portals and eCommerce stores to enterprise level systems. We
                  are into clean code, efficient architecture and the use of
                  forward thinking frameworks that ease the process of your
                  business scale up. Your vision is our mission and with you we
                  will develop systems which will power your digital success.
                </p>
              </div>
            </div>
            {/* Our PHP Developer Services  */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* The Benefits of PHP Development Services  */}
            <Benefits_section data={BenefitSection} />

            {/* Improve Your Product Development with Custom PHP Solutions: Secure, Scalable & Affordable  */}
            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default PHPWebDevelopmentService;
